import { render } from "./Ticker.vue?vue&type=template&id=984ee110"
import script from "./Ticker.vue?vue&type=script&lang=js"
export * from "./Ticker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__